import React from "react";

const disha_kadam = () => {
  return (
    <div>
      <h1>Disha Kadam</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Students with a CGPA above 8 and no backlogs were eligible to appear for
        the aptitude test.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The process began with an online aptitude test. The following day, the
        company delivered a presentation (PPT). Right after the presentation,
        the shortlisted candidates for the interviews were announced. The
        Results were also announced on the same day.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude test was conducted online and could be attempted from any
        location. It included:
      </p>

      <ul>
        <li>3 coding questions </li>
        <li>3 DBMS queries </li>
        <li>Logical reasoning questions </li>
        <li>Basic OS concepts </li>
        <li>OOPS pillars </li>
        <li>Output prediction of code snippets</li>
      </ul>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />A total of 19 students were shortlisted, of which 6 eventually
        received the final offer.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        There was no significant time to prepare after being shortlisted, as the
        aptitude results were announced immediately following the company PPT,
        and the interviews started right after.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>

      <ol>
        <li>
          <strong>Aptitude Round:</strong> Coding questions, DBMS queries,
          logical reasoning questions{" "}
        </li>
        <li>
          <strong>Technical Interview:</strong> ER diagrams, DBMS theory
          concepts (such as normalization), OOPS concepts, and DSA problems
          (sorting algorithms, finding the kth largest element in an array){" "}
        </li>
        <li>
          <strong>HR Round:</strong> Hobbies, strengths and weaknesses, reasons
          for choosing COEP, favorite teacher, etc.
        </li>
      </ol>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
      </p>

      <p>The interviewers emphasized three key areas:</p>

      <ul>
        <li>
          <strong>DSA (Data Structures &amp; Algorithms):</strong> Consistency
          is crucial—start early.{" "}
        </li>
        <li>
          <strong>OOPS (Object-Oriented Programming):</strong> GFG articles were
          particularly helpful for revision.{" "}
        </li>
        <li>
          <strong>DBMS:</strong> With focused preparation, this topic can yield
          good results in a relatively short timespan .{" "}
        </li>
      </ul>

      <p>
        Other areas, such as OS, computer networks, and additional technical
        subjects, were secondary.{" "}
      </p>

      <p>
        Most importantly, ensure you know your resume inside out
        <strong>.</strong> Avoid including anything you cannot confidently
        discuss.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        <strong>DSA:</strong> Striver’s SDE Sheet
        <br />
        <strong>OOPS:</strong> GeeksforGeeks articles
        <br />
        <strong>DBMS:</strong> CodeHelp by Babbar – DBMS Placement Series
        <br />
        <strong>OS:</strong> GeeksforGeeks articles
        <br />
        <strong>Computer Networks:</strong> Jim Kurose YouTube playlist
        <br />
        <strong>React:</strong> GeeksforGeeks Interview Questions collection
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        <strong>Pattern Recognition:</strong> Many questions repeat with small
        variations. Know fundamental Dynamic Programming concepts.
        <br />
        <strong>Practice consistently:</strong> Platforms like HackerRank and
        HackerEarth (easy/ medium difficulty) are useful.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Questions related to hobbies, clubs, and extracurricular activities were
        mainly asked in the HR round. In the technical round, such topics are
        less likely to be asked unless you bring them up during your
        self-introduction or discussions about technical contributions.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Interviewers often request ER diagrams, class diagrams, and OOPS system
        designs for given problem statements. Practice these in advance is
        helpful.
        <br />
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Stay calm and composed throughout the interview process.
        <br />
        While placements are stressful for all of us, remember to take care of
        yourself and not to over-stress—everything will work out well :)
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:dishak2005@gmail.com">dishak2005@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong> <a href="https://www.linkedin.com/in/dishakcodes/"> Disha Kadam</a>
      </p>
    </div>
  );
};

export default disha_kadam;
